module.exports = "/images/Chile.png?d899ffbe769fda13ced1e3cef1fc03c1";